import React from 'react';
import { SearchablePeriscopeV3WorkflowRuleList } from '@periscopes/general/workflow-rules';
export const EmailAlertWorkflowRulesTab = ({ index, sonarObjectId }) => {
    const targetUri = `v3/salesforce/workflow-alerts/${sonarObjectId}/workflow-rules`;
    return React.createElement(SearchablePeriscopeV3WorkflowRuleList, { parentIndex: index, uri: targetUri });
};
